export const SET_SELECTED_DOMAIN = "SET_SELECTED_DOMAIN";
export const SET_EVENT_STATE = "SET_EVENT_STATE";
export const SET_EVENT_Credit_Usage = "SET_EVENT_Credit_Usage";
export const SET_EVENT_TIMEZONE = "SET_EVENT_TIMEZONE";
export const GET_SELECTED_DOMAIN = "GET_SELECTED_DOMAIN";
export const CLEAR_SELECTED_DOMAIN = "CLEAR_SELECTED_DOMAIN";
